module.exports = __webpack_public_path__ + "static/media/dm-logo.f3f52e3a.png";